import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import avisos from '~/assets/img/avisos.png';
import {
	ContainerCss,
	AttentionText,
	Text,
	TextRed,
	DivButton,
	ButtonCss,
	ButtonWhite,
} from './styles';

export default function ModalConfirmar(props) {
	const { isOpen, toggle, toggleModalConfirm, aprovar } = props;
	return (
		<Modal
			isOpen={isOpen}
			size="lg"
			style={{ marginTop: '15vh', maxWidth: 500, width: '100%' }}>
			<ModalHeader toggle={toggle} />
			<ContainerCss>
				<div style={{ textAlign: 'center' }}>
					<img alt="avisos" src={avisos} />
				</div>
				<AttentionText aprovar={aprovar}>Atenção!</AttentionText>
				{!aprovar ? <TextRed>Pense com muita atenção.</TextRed> : <></>}
				<Text>
					{aprovar
						? 'É de extrema importância uma verificação com muita atenção aos dados do pedido solicitado.'
						: 'Ao reprovar uma cobrança não será mais possivel voltar atrás em sua escolha.'}
				</Text>
				<Text>
					{aprovar ? (
						'Lembre-se que os valores, serão debitados do seu Saldo em produtos.'
					) : (
						<></>
					)}
				</Text>
				<DivButton>
					<ButtonWhite onClick={toggleModalConfirm}>
						{aprovar ? 'Sim, Aprovar' : 'Sim, Reprovar'}
					</ButtonWhite>
					<ButtonCss onClick={toggle} aprovar={aprovar}>
						{aprovar ? 'Voltar' : 'Cancelar'}
					</ButtonCss>
				</DivButton>
			</ContainerCss>
		</Modal>
	);
}
